export default __webpack_public_path__ + "static/media/amazon pc done.921d3e04.png";